exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-footer[data-v-210caa50]{display:flex;justify-content:flex-end;gap:10px;padding:10px;border-top:1px solid #dee2e6}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-210caa50","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/common/AirAssignmentModal.vue
// module id = 1438
// module chunks = 0